"use strict";
/// <reference types="jquery"/>

Object.defineProperty(exports, "__esModule", { value: true });
require("./parametrage");
$(function () {
    if ($("#account-titles a.nav-link.active").length === 0) {
        $("#account-titles a.nav-link:first").trigger("click");
    }
    // Liste de régles : une regex et un message
    var passwordRules = [{ regex: /.{6,}/, message: "6 caractères", element: "nbre-caractere" }, { regex: /[A-ZÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ]+/, message: "Au moins 1 majuscule", element: "majuscule" }, { regex: /[a-záàâäãåçéèêëíìîïñóòôöõúùûüýÿæœ]+/, message: "Au moins 1 minuscule", element: "minuscule" }, { regex: /\d+/, message: "Au moins 1 nombre", element: "nombre" }, { regex: /\W+/, message: "Au moins 1 caractère spécial", element: "caractere-special" }];
    // Régles de nouveau mot de passe
    $("body").on("focus", ".new-password-checker", function () {
        if ($(this).next().hasClass("new-password-rules")) {
            $(this).next().removeClass("d-none");
        } else {
            // Insertion du conteneur de messages
            var $inputMessage = $("<div class=\"position-absolute new-password-rules\"></div>");
            for (var _i = 0, passwordRules_1 = passwordRules; _i < passwordRules_1.length; _i++) {
                var rule = passwordRules_1[_i];
                var $rule = $("<div id=\"" + rule.element + "\"><i class=\"fa fa-fw fa-times\"></i><i class=\"fa fa-fw fa-check\"></i> " + rule.message + "</div>");
                $inputMessage.append($rule);
            }
            $inputMessage.insertAfter($(this));
        }
    }).on("blur", ".new-password-checker", function () {
        $(this).next().addClass("d-none");
    }).on("keyup change", ".new-password-checker", function () {
        var $this = $(this),
            value = $this.val();
        for (var _i = 0, passwordRules_2 = passwordRules; _i < passwordRules_2.length; _i++) {
            var rule = passwordRules_2[_i];
            $this.next().find("#" + rule.element).toggleClass("password-ok", rule.regex.test(value));
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Account/index.ts
// module id = 601
// module chunks = 0